import { render, staticRenderFns } from "./solicitudDialogForm.vue?vue&type=template&id=36a0d669"
import script from "./solicitudDialogForm.vue?vue&type=script&lang=js"
export * from "./solicitudDialogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports